import React, { useCallback } from "react";
import "./style.less";
import { Dropdown } from "semantic-ui-react";
import { useSelector, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";

function CitySelector() {
  const cityList = useSelector(
    ({ geofence }) => geofence.availableCities,
    shallowEqual
  );
  const currentCityName = useSelector(
    ({ geofence }) => geofence.currentCityName
  );
  const history = useHistory();
  const changeCurrentCityName = useCallback(
    (e, { value }) => {
      history.push(`/city/${value}/geofences/`);
    },
    [history]
  );
  const options = cityList
    ? cityList.map((e, i) => ({ key: i, value: e, text: e }))
    : [];
  return (
    <div className="CitySelector">
      {cityList && currentCityName && cityList.length > 0 ? (
        <Dropdown
          search
          selection
          options={options}
          value={currentCityName}
          onChange={changeCurrentCityName}
        />
      ) : (
        <Dropdown
          selection
          value={"creating..."}
          onChange={changeCurrentCityName}
          options={[
            ...options,
            { key: 1000, value: "creating...", text: "creating..." }
          ]}
        />
      )}
    </div>
  );
}

CitySelector.defaultProps = {};

CitySelector.propTypes = {};

export default CitySelector;
